export const POST_DATA_STORE = 'POST_DATA_STORE';

export const SHOW_STORE_MODAL = 'SHOW_STORE_MODAL';
